
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgot_password",
      function () {
        return require("private-next-pages/auth/forgot_password.tsx");
      }
    ]);
  